import { createContext, useContext, useReducer } from "react";

export const initialSettings = {
	discussion: false,
	article: false,
	notes: false,
	comments: false,
	remark: false,
	reportError: false,
	statistics: false,
	questionLevel: false,
};

const initialState = {
	settings: initialSettings,
};

function settingsReducer(state, action) {
	switch (action.type) {
		case "toggle_settings":
			return {
				...state,
				settings: {
					...(["statistics", "questions"].includes(action.payload)
						? state.settings
						: initialSettings),
					statistics: state.settings.statistics,
					questionLevel: state.settings.questionLevel,
					[action.payload]:
						state.settings[action.payload] === action.id ? false : action.id,
				},
			};
		case "reset_settings":
			return {
				...state,
				settings: {
					...initialSettings,
					questionLevel: state.settings.questionLevel,
					statistics: state.settings.statistics,
				},
			};
		case "reset_all_settings":
			return {
				...state,
				settings: {
					...initialSettings,
				},
			};
		default:
			return state;
	}
}

const QuestionsListSettingsContext = createContext();

export function QuestionsListSettingsProvider({
	children,
	settings = {},
	aiFilterActive = false,
}) {
	const [state, dispatch] = useReducer(settingsReducer, {
		settings: {
			...initialState.settings,
			...settings,
		},
	});

	return (
		<QuestionsListSettingsContext.Provider
			value={{ state, dispatch, aiFilterActive }}
		>
			{children}
		</QuestionsListSettingsContext.Provider>
	);
}

export function useQuestionsListSettings() {
	const context = useContext(QuestionsListSettingsContext);
	if (context === undefined) {
		return {};
	}
	return context;
}
